<template>
  <div class="no-results">
    <h1>Geen resultaten gevonden, pas je filters aan!</h1>
  </div>
</template>

<script>
export default {
  name: "NoResultsFound",
};
</script>